import React from 'react';
import Drawer from '@mui/material/Drawer';
import { drawerStyle } from './style';

export default function Panel({ children }) {
  return (
    <Drawer sx={drawerStyle} variant="permanent" anchor="right">
      {children}
    </Drawer>
  );
}
